export default {
    namespaced: true,
    state: {
        templates: [],
        gSuiteTemplate: []
    },
    getters: {
        getTemplates: (state) => (action) => {
            if (action === '1') {
                return state.gSuiteTemplate;
            } else {
                return state.templates;
            }
        }
    },
    mutations: {
        templatesMutate(state, payload) {
            state.templates = payload
        },
        gSuiteTemplateMutate(state, payload) {
            state.gSuiteTemplate = payload;
        }
    },
    actions: {
        setTemplates(context , payload) {
            let temp_array = [];
            switch (payload.action) {
                case '0':
                    temp_array = [{
                        type: "A",
                        name: `${payload.domain}`,
                        content: `${payload.ip}`,
                        ttl: 14400,
                        proxied: true
                    },{
                        type: "A",
                        name: `www.${payload.domain}`,
                        content: `${payload.ip}`,
                        ttl: 14400,
                        proxied: true
                    },{
                        type: "A",
                        name: `mail.${payload.domain}`,
                        content: `67.202.70.12`,
                        ttl: 14400,
                    },{
                        type: "CNAME",
                        name: `webmail.${payload.domain}`,
                        content: `mail.${payload.domain}`,
                        ttl: 14400,
                    },{
                        type: "CNAME",
                        name: `ftp.${payload.domain}`,
                        content: `${payload.domain}`,
                        ttl: 14400,
                    },{
                        type: "CNAME",
                        name: `imap.${payload.domain}`,
                        content: `mail.${payload.domain}`,
                        ttl: 14400,
                    },{
                        type: "CNAME",
                        name: `autoconfig.${payload.domain}`,
                        content: `mail.${payload.domain}`,
                        ttl: 14400,
                    },{
                        type: "CNAME",
                        name: `autodiscover.${payload.domain}`,
                        content: `mail.${payload.domain}`,
                        ttl: 14400,
                    },{
                        type: "CNAME",
                        name: `cf.${payload.domain}`,
                        content: `${payload.domain}`,
                        ttl: 14400,
                    },{
                        type: "CNAME",
                        name: `smtp.${payload.domain}`,
                        content: `mail.${payload.domain}`,
                        ttl: 14400,
                    },{
                        type: "CNAME",
                        name: `pop.${payload.domain}`,
                        content: `mail.${payload.domain}`,
                        ttl: 14400,
                    },{
                        type: "CNAME",
                        name: `whm.${payload.domain}`,
                        content: `mail.${payload.domain}`,
                        ttl: 14400,
                    },{
                        type: "CNAME",
                        name: `cpanel.${payload.domain}`,
                        content: `mail.${payload.domain}`,
                        ttl: 14400,
                    },{
                        type: "MX",
                        name: `${payload.domain}`,
                        content: `mail.${payload.domain}`,
                        ttl: 14400,
                        priority: 0,
                    },{
                        type: "TXT",
                        name: `${payload.domain}`,
                        content: `v=spf1 a mx include:spf.securedserverspace.com ~all`,
                        ttl: 14400,
                    },{
                        type: "TXT",
                        name: `_dmarc.${payload.domain}`,
                        content: `v=DMARC1; p=none`,
                        ttl: 14400,
                    },{
                        type: "SRV",
                        data:{
                            service:'_autodiscover',
                            proto: `_tcp`,
                            name: `${payload.domain}`,
                            target: `cpanelemaildiscovery.cpanel.net`,
                            port: 443,
                            priority: 0,
                            weight: 0,
                        }
                    }];
                    context.commit('templatesMutate', temp_array)
                    break;
                case '1':
                    temp_array = [{
                        type: "MX",
                        name: `${payload.domain}`,
                        content: 'aspmx.l.google.com',
                        ttl: 3600,
                        priority: 1,
                    },{
                        type: "MX",
                        name: `${payload.domain}`,
                        content: 'alt1.aspmx.l.google.com',
                        ttl: 3600,
                        priority: 5,
                    },{
                        type: "MX",
                        name: `${payload.domain}`,
                        content: 'alt2.aspmx.l.google.com',
                        ttl: 3600,
                        priority: 5,
                    },{
                        type: "MX",
                        name: `${payload.domain}`,
                        content: 'alt3.aspmx.l.google.com',
                        ttl: 3600,
                        priority: 10,
                    },{
                        type: "MX",
                        name: `${payload.domain}`,
                        content: 'alt4.aspmx.l.google.com',
                        ttl: 3600,
                        priority: 10,
                    }];
                    context.commit('gSuiteTemplateMutate', temp_array)
                    break;
            }


        }
    }
}
